module.exports = __webpack_public_path__ + "static/media/login_img.b7645606.png";